"use client";

import React from "react";
import { Instagram, Facebook, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const socialImages = [{
  src: "https://blkn.com.au/wp-content/uploads/2026/03/1J6A8127-e1773971660152.jpg?v=it40tcxm3ar",
  alt: "VIP tables with luxury bottle service at BLKN"
}, {
  src: "https://blkn.com.au/wp-content/uploads/2026/03/1J6A8392.jpg?v=8tmfa1hrsug",
  alt: "Champagne bottles with sparklers lighting up the night"
}, {
  src: "https://blkn.com.au/wp-content/uploads/2026/03/1J6A0340-scaled.jpg?v=q47eawdehj",
  alt: "Intense strobe lights and club atmosphere"
}, {
  src: "https://blkn.com.au/wp-content/uploads/2026/03/1J6A5984-scaled-e1773972168782.jpg?v=4nhq371big",
  alt: "Balkan flags waving in the energetic crowd"
}];
const socialLinks = [{
  icon: Instagram,
  label: "Instagram",
  href: "https://instagram.com"
}, {
  icon: Facebook,
  label: "Facebook",
  href: "https://facebook.com"
}, {
  icon: Twitter,
  label: "Twitter",
  href: "https://twitter.com"
}];
export default function FollowUs() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="follow-us" ref={ref} className={`dark bg-background text-foreground py-24 relative overflow-hidden transition-opacity duration-1000 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      {}
      

      {}
      <div className="w-full grid grid-cols-2 md:grid-cols-4 gap-0">
        {socialImages.map((image, i) => <div key={i} data-index={i} className="group relative aspect-square overflow-hidden bg-neutral-900 cursor-pointer">
            <img src={image.src} alt={image.alt} className="h-full w-full object-cover transition-all duration-700 ease-out grayscale group-hover:grayscale-0 group-hover:scale-105" />
            {}
            <div className="absolute inset-0 bg-black/20 pointer-events-none group-hover:bg-transparent transition-colors duration-500" />
          </div>)}
      </div>

      {}
      <div className="flex justify-center items-center gap-12 mt-16">
        {socialLinks.map((social, i) => <Link key={i} to={social.href} newTab className="group flex flex-col items-center justify-center gap-2 transition-transform hover:-translate-y-1 duration-300" aria-label={social.label} data-index={i}>
            <div className="p-3 rounded-full border border-white/10 group-hover:border-white/50 transition-colors duration-300">
              <social.icon strokeWidth={1} className="w-6 h-6 text-white/70 group-hover:text-white transition-colors duration-300" />
            </div>
            <span className="text-[10px] uppercase tracking-widest text-white/40 group-hover:text-white/80 transition-colors duration-300">
              {social.label}
            </span>
          </Link>)}
      </div>
    </section>;
}